import React, { useContext } from 'react';
import AdminDashboard from '../components/AdminDashboard/AdminDashboard';
import { AuthContext } from '../context/AuthContext';

const AdminPanel = () => {
  // Get the correct variables from context:
  const { userRole, isLoggedIn, loading } = useContext(AuthContext);

  console.log('AdminPanel userRole:', userRole, typeof userRole);

  if (loading) return <div>Loading...</div>;

  if (!isLoggedIn || userRole !== 'admin') {
    return (
      <div className="max-w-2xl mx-auto p-6 text-center">
        <h2 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h2>
        <p>Only administrators can access this page.</p>
      </div>
    );
  }

  return <AdminDashboard />;
};

export default AdminPanel;
